import { render } from "./FlowNodeBlock.vue?vue&type=template&id=5caeb2e8&scoped=true&ts=true&class=test"
import script from "./FlowNodeBlock.vue?vue&type=script&lang=ts"
export * from "./FlowNodeBlock.vue?vue&type=script&lang=ts"

import "./FlowNodeBlock.vue?vue&type=style&index=0&id=5caeb2e8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caeb2e8"]])

export default __exports__